import {Component, forwardRef, Input, OnInit} from '@angular/core';
import {ControlValueAccessor, FormBuilder, FormGroup, NG_VALUE_ACCESSOR, Validators} from '@angular/forms';

@Component({
  selector: 'app-parse',
  templateUrl: './parse.component.html',
  styleUrls: ['./parse.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef( () => ParseComponent),
      multi: true
    }
  ]
})
export class ParseComponent implements OnInit, ControlValueAccessor {

  form: FormGroup;
  constructor(private fb: FormBuilder) {
    this.form = this.fb.group({
      format: ['', Validators.required],
      padLeft: [false, Validators.required],
      calcValue: null,
    });
    this.form.valueChanges.subscribe(val => {
      this.propagateChange(val);
    });
  }

  propagateChange = (_: any) => {};
  ngOnInit() {
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
  }

  setDisabledState(isDisabled: boolean): void {
  }

  writeValue(obj: any): void {
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/import-template/component/parse/parse.component.ts